import React from 'react';
import { Link } from 'react-router-dom';

const BieberFooter = () => {
  return (
    <footer 
      className="py-8 transition-colors duration-300"
      style={{ 
        backgroundColor: 'var(--bieber-primary-color, #2d5a2f)',
        color: 'var(--bieber-text-color, #ffffff)'
      }}
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Kontakt */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <div className="space-y-2 text-sm">
              <p>Liederkranz Bieber 1847 e.V.</p>
              <p>Würzburger Straße 1</p>
              <p>63599 Biebergemünd</p>
              <p>Telefon: 06050 / 1234567</p>
              <p>E-Mail: info@liederkranz-bieber.de</p>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links</h3>
            <div className="space-y-2">
              <Link
                to="/bieber-info/impressum"
                className="block text-sm transition-colors duration-200 hover:opacity-80"
                style={{ color: 'var(--bieber-link-color, #ffffff)' }}
              >
                Impressum
              </Link>
              <Link
                to="/bieber-info/datenschutz"
                className="block text-sm transition-colors duration-200 hover:opacity-80"
                style={{ color: 'var(--bieber-link-color, #ffffff)' }}
              >
                Datenschutz
              </Link>
              <Link
                to="/"
                className="block text-sm transition-colors duration-200 hover:opacity-80"
                style={{ color: 'var(--bieber-link-color, #ffffff)' }}
              >
                Zu StimmArt
              </Link>
            </div>
          </div>

          {/* Über uns */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Über uns</h3>
            <p className="text-sm">
              Der Liederkranz Bieber 1847 e.V. ist ein traditionsreicher Gesangverein, 
              der seit über 175 Jahren das deutsche Liedgut pflegt und Menschen 
              durch Musik zusammenbringt.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Liederkranz Bieber 1847 e.V. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default BieberFooter; 